export default __webpack_public_path__ + "media/images/neu-d79beaa0.png";